import { TIMMER } from './constants';

const initialState = {
  tempo: undefined,
  situacao: undefined,
};

// eslint-disable-next-line default-param-last
export default function temporizador(state = initialState, action) {
  switch (action.type) {
    case TIMMER:
      return {
        ...state,
        tempo: action.values.tempo,
        situacao: action.values.situacao,
      };

    default:
      return {
        ...state,
        tempo: undefined,
        situacao: 'Zerado',
      };
  }
}
